import * as React from "react"

import { StaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Team = () => (
  <StaticQuery
    query={graphql`
      query TeamQuery {
        allStaffsJson {
          edges {
            node {
              name
              url
              image {
                childImageSharp {
                  gatsbyImageData(width: 75, height: 75)
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <section id="team" className="section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-title-header text-center">
                <h1 className="section-title wow fadeInUp" data-wow-delay="0.2s">Team</h1>
                <p className="wow fadeInDown" data-wow-delay="0.2s">SRE NEXT 2022 スタッフリスト</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 staffs">
              {data.allStaffsJson.edges.map(edge => edge.node).map((staff, index) => {
                const image = getImage(staff.image)
                return (
                  <a href={staff.url} target="_blank" rel="noopener" key={index}>
                    <GatsbyImage className="img-fluid" image={image} alt={staff.name} />
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      </section>
    )}
  />
)

export default Team
